import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

fetch('./assets/config/configuration.json')
  .then(response => response.json())
  .then(config => {
    if (config.production) {
      enableProdMode();
      console.log = () => {};
      if (window) {
        window.console.log = () => {};
        window.console.info = () => {};
        window.console.warn = () => {};
      }
    }

    return platformBrowserDynamic().bootstrapModule(AppModule);
  })
  .catch(err => console.error('Error loading configuration:', err));